import React, {useState, useEffect} from 'react';
import { Modal } from 'react-responsive-modal';
import { toast } from 'react-toastify';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import InputText from './InputText';
import {default as badge} from '../../../images/Industry_Experts_Badge.svg';
import Filter from '../../Common/Filter/Filter';
import { INDUSTRY_CHOICES } from '../../../utils/const';
import 'react-responsive-modal/styles.css';
import './IndustryExpertsJoinModal.scss';
import ToggleSwitch from './ToggleSwitch';
import countriesJsonData from './../../IndustryExperts/schemas/countries.json'


const IndustryExpertsJoinModal = ({
  isOpen, 
  onClose,
}) => {

  const tempForm = {
    firstName : '',
    lastName : '',
    companyName: '',
    website: '',
    role: '',
    email : '',
    country : '',
    state: '',
    companyDesc: '',
    companySpec: '',
    companySize: '',
    isCreateProfile: 'No',
    isAffiliateProgram: 'No',
    isJoinIndustryExperts: 'No',
    isAllowNewsLetter: 'No'
  }

  const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [open, setOpen] = useState(isOpen);
  const [form, setForm] = useState(tempForm);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);

  /* Country List */
  const countryList = []
  countriesJsonData.map((item, index) => {
    countryList.push({ "label" : item.name })
  })

  /* Form submited message */
  const [loading, setLoading] = useState(false)

  let textBoxMsg = 'This is a required field.'
  let selectMsg = 'Please select an option.'
  const [emailMsg, setEmailMsg] = useState('This is a required field.');


  useEffect(() => {
    document.body.parentElement.style.overflow = 'hidden';
    return () => {
      document.body.parentElement.style.overflow = 'auto';
    }
  }, []);

  const onCloseModal = () => {
    onClose();
    setOpen(false);
  }

  const onInputChange = (e, type) => {
    const {value} = e.target;
    if(type=='email') {
      if(value=="") {
        setEmailMsg('This is a required field.')
        setInvalidEmail(true);
      }
      else if(!emailPattern.test(value)){
        setEmailMsg('Please enter a valid email address.')
        setInvalidEmail(true);
      } else {
        setEmailMsg('')
        setInvalidEmail(false);
      }
    }
    setForm({
      ...form,
      [type] : value,
    });
  }

  const onIndustryFilter = (value, type) => {
    setForm({
      ...form,
      [type] : value,
    });
  };

  const onCustomerFilter = (value, type) => {
    setForm({
      ...form,
      [type] : value,
    });
  }


  const apiPath = '/api/customer/form/'

  const onFormSubmit = async (event) => {

    if(validateForm()) {
      setIsFormValid(true);
      const data = { ...form};
      //console.log('data', data);
      const email = form.email
      const firstName = form.firstName
      const lastName = form.lastName

      let customerId = 0

      try { 
        setLoading(true)

        /* Check customer is exist OR not */
        const findCustomer = await fetch(`${apiPath}?email=${email}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.id != "") {
              return response.id
            } else {
              return false
            }
          })
        
        /* Create OR update customer */
        if (findCustomer == false) {
          const createCustomer = await fetch(apiPath, {
            method: 'POST',
            body: JSON.stringify({ firstName, lastName, email }),
            headers: { 'Content-Type': 'application/json' },
          })
            .then((response) => response.json())
            .then((response) => {
              return response.id
            })
          customerId = createCustomer
        } else {
          const id = findCustomer
          const updateCustomer = await fetch(apiPath, {
            method: 'PUT',
            body: JSON.stringify({ id, firstName, lastName, email }),
            headers: { 'Content-Type': 'application/json' },
          })
            .then((response) => response.json())
            .then((response) => {
              return response.id
            })
          customerId = updateCustomer
        }      
        //console.log("Final customerId: ",customerId)

        /* Update Customer Form Field*/
        const updateFormData1 = [
          {
            customer_id: customerId,
            name: 'Industry Experts Company Name',
            value: form.companyName,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Website',
            value: form.website,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Role',
            value: form.role,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Country',
            value: form.country ,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts State',
            value: form.state,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Company Description',
            value: form.companyDesc,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Company Specify',
            value: form.companySpec,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Company Size',
            value: form.companySize,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Is Create Profile',
            value: form.isCreateProfile,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Is Affiliate Program',
            value: form.isAffiliateProgram,
          }
        ]
        const updateFormData2 = [
          {
            customer_id: customerId,
            name: 'Industry Experts Is Join Industry Experts',
            value: form.isJoinIndustryExperts,
          },
          {
            customer_id: customerId,
            name: 'Industry Experts Is Allow NewsLetter',
            value: form.isAllowNewsLetter,
          }
        ]

        await fetch(apiPath, {
          method: 'PATCH',
          body: JSON.stringify(updateFormData1),
          headers: { 'Content-Type': 'application/json' },
        })
        await fetch(apiPath, {
          method: 'PATCH',
          body: JSON.stringify(updateFormData2),
          headers: { 'Content-Type': 'application/json' },
        })

        onClose();  //Close popup
        setLoading(false)
        toast.success(`Thank you for submitting the application, we'll be in touch soon.`, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })

      } catch (error) {
        onClose();  //Close popup
        setLoading(false)
        toast.error(`Please try again later after some time.`, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      }

    } else {
      setIsFormValid(false);
    }

  }

  const validateForm = () => {
    let isValid = true;
    for(let key in form) {
      //console.log("form: ", key, " => ", form[key])
      if(form[key] === ''){
        isValid = false;
      }
    }
    return isValid;
  }

  return (
    <Modal 
      open={open} 
      onClose={onCloseModal} 
      classNames={{root : "industry-experts-join-modal"}} >
      <div className="noissue__industry-experts__join-modal">
        <CommunityImg className="badge" src={badge} alt="badge" />
        <div className="heading">
          <div className="title">Industry Experts Program Application</div>
          <div className="sub-title"> The Industry Experts Program is made up of experts spanning all specialties - from marketing, to logistics, to sustainability. If you think we would partner well together, please fill out this form and we’ll be in touch!</div>
          {/* Join the Eco-Alliance and start making a difference! */}
        </div>
        <div className="form-container"> 

          <div className="full-name">
            <div className="formElement">
              <InputText 
                placeholder="First Name" 
                name="firstName"
                onChange={(e)=> onInputChange(e, 'firstName')} 
                cls={`first-name-input ${form.firstName === '' && !isFormValid && 'error'}`} 
              />
              { form.firstName === '' && !isFormValid && <div className="form-error">{textBoxMsg}</div> }
            </div>            
            <div className="formElement">
              <InputText 
                placeholder="Last Name" 
                name="lastName"
                cls={`${form.lastName === '' && !isFormValid && 'error'}`} 
                onChange={(e)=> onInputChange(e, 'lastName')} 
              />
              { form.lastName === '' && !isFormValid && <div className="form-error">{textBoxMsg}</div> }
            </div>
          </div>

          <div className="company">
            <div className="formElement">
              <InputText 
                placeholder="Company Name" 
                name="companyName"
                cls={`${form.companyName === '' && !isFormValid && 'error'}`} 
                onChange={(e)=> onInputChange(e, 'companyName')} 
              />
              { form.companyName === '' && !isFormValid && <div className="form-error">{textBoxMsg}</div> }
            </div>
          </div>

          <div className="full-name">
            <div className="formElement">
              <InputText 
                placeholder="Website" 
                name="website"
                onChange={(e)=> onInputChange(e, 'website')} 
                cls={`first-name-input ${form.website === '' && !isFormValid && 'error'}`} 
              />
              { form.website === '' && !isFormValid && <div className="form-error">{textBoxMsg}</div> }
            </div>
            <div className="formElement">
              <InputText 
                placeholder="Role" 
                name="role"
                cls={`${form.role === '' && !isFormValid && 'error'}`} 
                onChange={(e)=> onInputChange(e, 'role')} 
              />
              { form.role === '' && !isFormValid && <div className="form-error">{textBoxMsg}</div> }
            </div>
          </div>

          <div className="email">
            <div className="formElement">
              <InputText 
                placeholder="Email Address" 
                name="email"
                cls={`${(form.email === '' || invalidEmail )&& !isFormValid && 'error'}`} 
                onChange={(e)=> onInputChange(e, 'email')} 
              />
              { (form.email === '' || invalidEmail) && !isFormValid && <div className="form-error">{emailMsg}</div> }
            </div>
          </div>

          <div className="filters">
            <div className="formElement">
              <Filter
                cls={`industry-experts-slider-filter ${form.country === '' && !isFormValid && 'errorSelect'}`}
                width={280}
                defaultSelection="Country"
                filterData={countryList.map(item => item.label)}
                onSelect={(item)=>onCustomerFilter(item, 'country')}
              />
              { form.country === '' && !isFormValid && <div className="form-error">{selectMsg}</div> }
              
            </div>
            <div className="formElement">
              <InputText 
                placeholder="State" 
                name="state"
                cls={`${form.state === '' && !isFormValid && 'error'}`} 
                onChange={(e)=> onInputChange(e, 'state')} 
              />
              { form.state === '' && !isFormValid && <div className="form-error">{textBoxMsg}</div> }
            </div>
          </div>

          <div>
            <div className="formElement">
              <span className="label"> Which of the following best describes your company? </span>
              <Filter
                cls={`industry-experts-slider-filter industry-expert-company-filter ${form.companyDesc === '' && !isFormValid && 'errorSelect'}`}
                width={280}
                defaultSelection="Please choose one..."
                filterData={['Customer Experience', 'Finance', 'Logistics', 'Marketing', 'Marketplace', 'Sourcing', 'Sustainability']}
                onSelect={(item)=>onCustomerFilter(item, 'companyDesc')}
              />
              { form.companyDesc === '' && !isFormValid && <div className="form-error">{selectMsg}</div> }
            </div>
          </div>

          <div>
            <div className="formElement">
              <span className="label"> Please specify </span>
              <Filter
                cls={`industry-experts-slider-filter industry-expert-company-filter ${form.companySpec === '' && !isFormValid && 'errorSelect'}`}
                width={280}
                defaultSelection="Please choose one..."
                filterData={['Fulfillment', 'Inventory Management', 'Shipping', 'Wholesale', '3PL']}
                onSelect={(item)=>onCustomerFilter(item, 'companySpec')}
              />
              { form.companySpec === '' && !isFormValid && <div className="form-error">{selectMsg}</div> }
            </div>
          </div>

          <div>
            <div className="formElement">
              <span className="label"> Which of the following best describes your company size? </span>
              <Filter
                cls={`industry-experts-slider-filter industry-expert-company-filter ${form.companySize === '' && !isFormValid && 'errorSelect'}`}
                width={280}
                defaultSelection="Please choose one..."
                filterData={['Consultant (individual)', 'Agency (boutique)', 'Enterprise (mid to large size company)']}
                onSelect={(item)=>onCustomerFilter(item, 'companySize')}
              />
              { form.companySize === '' && !isFormValid && <div className="form-error">{selectMsg}</div> }
            </div>
          </div>

          <div className="toggle-switch-container">
            <span className="label">
              Would you like to create a profile for our Industry Experts Community Page? 
            </span>
            <ToggleSwitch onChange={(value)=> onCustomerFilter(value == true ? "Yes" : "No", 'isCreateProfile')} />
          </div>

          <div className="toggle-switch-container">
            <span className="label">
            Are you interested in joining our affiliate program?
            </span>
            <ToggleSwitch onChange={(value)=> onCustomerFilter(value == true ? "Yes" : "No", 'isAffiliateProgram')} />
          </div>

          <div className="toggle-switch-container">
            <span className="label">
            Would you like to join our Industry Experts Channel?
            </span>
            <ToggleSwitch onChange={(value)=> onCustomerFilter(value == true ? "Yes" : "No", 'isJoinIndustryExperts')} />
          </div>

          <div className="toggle-switch-container">
            <span className="label">
            Are you interested in receiving our monthly Industry Experts newsletter?
            </span>
            <ToggleSwitch onChange={(value)=> onCustomerFilter(value == true ? "Yes" : "No", 'isAllowNewsLetter')} />
          </div>

          <div className="formElement">
            <button className="industry-experts-join-button" onClick={onFormSubmit}>Submit { loading && <span className="industryExpertsLoader"></span> } </button>
            <div className="message">
              Thanks! You can expect to hear back from our Industry Experts team within 1-2 business days.
            </div>
          </div>

          {/* <CommunityImg src={bottomImg} alt="eco alliance bottom" /> */}
      </div>

      </div>
    </Modal>
  )
}

export default IndustryExpertsJoinModal ;